/* eslint-disable prefer-rest-params */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/camelcase */
import React, { Component } from 'react';

import TooltipClose from '@/components/common/TooltipCloseSvg';
import { TmCart } from '@/tscapi/model/cart';
import { TmProduct, TmEdp } from '@/tscapi/model/product';
import { Cookie } from '@/tscapi/utils/cookie';

const clientID = 'tsc';
const options = { autoCalculate: false };

interface MyState {
    selectedEdpData: TmEdp;
    productData: TmProduct;
    itemNo: number;
    foundDuplicate: boolean;
    showBanner: boolean;
    widgetConfig: {};
    foundDuplicateProductName: string;
}
interface MyProps {
    detail: { cart: TmCart };
}

export default class TrueFitCart extends Component<MyProps, MyState> {
    constructor(props: Readonly<MyProps>) {
        super(props);
    }

    state = {
        selectedEdpData: null,
        productData: null,
        itemNo: null,
        foundDuplicate: false,
        showBanner: false,
        widgetConfig: null,
        foundDuplicateProductName: null,
    };

    loadTrueFitLibrary(): void {
        const queryStrings = ['www.tsc.ca', 'origin1.tsc.ca', 'origin1s.tsc.ca'];
        function includes(array, element) {
            return array.indexOf(element) >= 0;
        }
        const pageUrl = window.location.hostname;
        const isProd = includes(queryStrings, pageUrl);
        const environment = isProd ? 'prod' : 'staging';
        /* eslint-disable */
        // prettier-ignore
        (function(r,e,o){
            var w=window,d=document,t,s,x;
            w.tfcapi=t=w.tfcapi||function(){t.q=t.q||[]; t.q.push(arguments);};
            t('init', {storeKey: r, environment: e, ...o});
            x=d.getElementsByTagName('script')[0];
            s=d.createElement('script');
            s.type='text/javascript';s.async=true;
            s.src='https://'+r+'-cdn'+(e==='dev'||e==='staging'?'.'+e:'')+ '.truefitcorp.com/fitrec/'+r+'/js/tf-integration.js';
            x.parentNode.insertBefore(s,x);
          // Don't change anything above this line
          })(clientID,environment,{autoCalculate:false});
        /* eslint-enable */
    }

    unhideBannerArea() {
        const noticeBanner = document.getElementById('cartNotices') as HTMLElement;
        if (noticeBanner) {
            if (noticeBanner.classList.contains('hidden')) {
                noticeBanner.classList.remove('hidden');
            }
        }
    }

    calculateAvailableSizes(selectedEdpData, productData) {
        //return colon separated list of sizes
        let result = [] as any;
        const allAvailableSizes = [];
        if (productData.Sizes != null) {
            productData.Sizes.forEach((size) => {
                result = productData.Edps.filter(
                    (edps) =>
                        edps.SizeDimensionId == size.DimensionId &&
                        edps.StyleDimensionId == selectedEdpData.StyleDimensionId &&
                        edps.Inventory > 0,
                );
                if (result.length > 0) {
                    allAvailableSizes.push(result[0].Size);
                }
            });
        }
        //console.log(allAvailableSizes.join(':'));
        return allAvailableSizes.join(':');
    }
    configWidget(): void {
        const cookie: Cookie = new Cookie();
        let userID = null;

        const itemNo = this.state.selectedEdpData.ItemNo.replace(/-/g, '');

        const productEdp = this.props.detail.cart.Products.filter((x) => {
            return x.ItemNo == itemNo;
        });

        if (
            cookie.UserAccessToken != undefined &&
            cookie.UserAccessToken.Token.length > 0 &&
            cookie.UserAccessToken.Edp > 0
        ) {
            userID = cookie.UserAccessToken.Edp;
        }
        const widgetConfig = {
            products: {},
        };
        if (userID) {
            widgetConfig['userId'] = userID;
            widgetConfig['registered'] = userID ? true : false;
        }
        widgetConfig['locale'] = cookie.Language;

        widgetConfig.products[itemNo] = {
            availableSizes: this.calculateAvailableSizes(this.state.selectedEdpData, productEdp[0]),
        };
        if (this.state.selectedEdpData.Style) {
            widgetConfig.products[itemNo]['colorId'] = this.state.selectedEdpData.Style;
        }
        this.setState({ widgetConfig: widgetConfig }, window.tfcapi('calculate', widgetConfig));
        if (window.tfcapi) {
            window.tfcapi(
                'event',
                'tfc-fitrec-product',
                'widgetResult',
                function (context) {
                    this.setState({ showBanner: true }, this.unhideBannerArea());
                }.bind(this),
            );
        }
    }

    bannerText = () => {
        const cookie: Cookie = new Cookie();
        return cookie.Language.toLowerCase() == 'en_ca'
            ? `We noticed you have two sizes in your cart for ${this.state.foundDuplicateProductName}.`
            : `Nous avons remarqué que vous avez deux tailles dans votre panier pour ${this.state.foundDuplicateProductName}.`;
    };
    bannerText2 = () => {
        const cookie: Cookie = new Cookie();
        return cookie.Language.toLowerCase() == 'en_ca'
            ? 'Use True Fit to find your exact size.'
            : 'Utilisez True Fit pour trouver votre taille exacte.';
    };

    hideShowMerge = () => {
        this.setState({ showBanner: false });
    };

    isSizeSampling = (detail) => {
        //check for duplicate product item numbers, with identical styles but different edps
        // also checks if elgible (by checking producttypepath id against fashion (100047) and shoes (128153)
        let productIndex = -1;
        let updatedDetails = this.props.detail;
        if (detail) {
            updatedDetails = detail;
        }
        for (let i = updatedDetails.cart.CartLines.length - 1; i >= 0; i--) {
            productIndex = updatedDetails.cart.CartLines.findIndex((x) => {
                return (
                    x.CartLineItem.ItemNo === updatedDetails.cart.CartLines[i].CartLineItem.ItemNo &&
                    x.CartLineItem.StyleDimensionId ===
                        updatedDetails.cart.CartLines[i].CartLineItem.StyleDimensionId &&
                    x.CartLineItem.EdpNo !== updatedDetails.cart.CartLines[i].CartLineItem.EdpNo &&
                    ['100047', '128153', '3002802'].includes(
                        updatedDetails.cart.Products[
                            updatedDetails.cart.Products.findIndex((y) => {
                                return y.ItemNo === x.CartLineItem.ItemNo;
                            })
                        ].ProductTypePath[0]?.FacetValueId,
                    )
                );
            });
            //console.log(productIndex);
            if (productIndex != -1) {
                this.setState(
                    {
                        foundDuplicate: true,
                        foundDuplicateProductName: updatedDetails.cart.Products.find(
                            (x) => x.ItemNo == updatedDetails.cart.CartLines[productIndex].InCart.ItemNo,
                        ).Name,
                        selectedEdpData: updatedDetails.cart.CartLines[i].CartLineItem,
                        itemNo: parseInt(updatedDetails.cart.CartLines[i].CartLineItem.ItemNo, 10),
                    },
                    () => {
                        // found duplicate, load truefit library and setup widget in dom
                        this.loadTrueFitLibrary();
                        this.configWidget();
                    },
                );
                break;
            } else {
                this.setState({
                    foundDuplicate: false,
                    selectedEdpData: updatedDetails.cart.CartLines[i].CartLineItem,
                    itemNo: parseInt(updatedDetails.cart.CartLines[i].CartLineItem.ItemNo, 10),
                });
            }
        }
    };
    setupEventListener = () => {
        document.addEventListener(
            'tf-update',
            function (e: CustomEvent) {
                const truefitCartElement = document.getElementById('tf-cart-wrapper') as HTMLElement;
                if (truefitCartElement != undefined) {
                    //do something with {e.detail}
                    //check if the customer has 2 identical products in cart (but of different sizes)
                    this.isSizeSampling(e.detail);
                }
            }.bind(this),
            false,
        );
    };
    componentDidMount() {
        //bind eventhandler

        this.isSizeSampling(null);
        this.setupEventListener();
    }

    render() {
        const styles = {
            truefit__container: {
                display: this.state.showBanner ? 'flex' : 'none',
                background: '#fff',
                border: '2px solid #ea0c0c',
                padding: '20px 20px',
            },
            truefit__logo: {
                width: '24px',
                height: '20px',
                marginRight: '15px',
            },
            truefit__message: { fontSize: '14px', lineHeight: '20px' },
            truefit__button: { textDecoration: 'underline', border: '0' },
        };
        return (
            <>
                {this.state.foundDuplicate && (
                    <div style={styles.truefit__container} className="notice-card">
                        <div style={styles.truefit__logo}>
                            <svg
                                width="126"
                                height="126"
                                viewBox="-242 334 126 126"
                                style={{ height: '20px', width: '20px' }}
                            >
                                <path fill="#fff" d="M-220 350h83v97h-83z" />
                                <path
                                    d="M-128 334h-102c-6.6 0-12 5.4-12 12v102c0 6.6 5.4 12 12 12h102c6.6 0 12-5.4 12-12V346c0-6.6-5.4-12-12-12zm-15.7 36.4h-25.7v69.8h-18.9v-69.8h-25.6v-15.8h70.2v15.8z"
                                    fill="#d31245"
                                />
                            </svg>
                        </div>
                        <div style={styles.truefit__message}>
                            <b>{this.bannerText()}</b>
                            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                <span style={{ marginRight: '10px' }}>{this.bannerText2()}</span>
                                <span>
                                    {this.state.selectedEdpData && (
                                        <div
                                            className="tfc-fitrec-product"
                                            data-styleid={this.state.itemNo}
                                            data-colorid={this.state.selectedEdpData.Style}
                                        />
                                    )}
                                </span>
                            </div>
                        </div>
                        <button className="notice-card__close" onClick={() => this.hideShowMerge()}>
                            <TooltipClose />
                        </button>
                    </div>
                )}
            </>
        );
    }
}
